export default __webpack_public_path__ + "static/media/defaultImage.655488c2.png";